import { bulkTranslation } from 'Base/modules/bk/component-property-providers/bk-translations';
import constants from 'Base/shared/bk/modules/constants';

class BkModalDataPin extends HTMLElement {
    #modal;
    #errorText;
    static URL_MIGRATION_BASE = `${constants.contextPath}app/sysadm/migration`;
    static VALIDATE_PIN = `${this.URL_MIGRATION_BASE}/validatePin`;

    constructor() {
        super();
    }

    showModal({
        submitFunction,
        onCloseCallback,
        disableSubmitAt,
        submitText = 'cs.button.saveAndSet',
        headText = 'cs.text.enterDataPINchangesUserAdminApplied',
    } = {}) {
        const { titleText, headTextValue, labelText, submitTextValue, errorText } = bulkTranslation({
            titleText: 'cs.title.enterDataPIN',
            headTextValue: headText,
            labelText: 'client.accountDataPIN',
            submitTextValue: submitText,
            errorText: '214',
        });
        this.#errorText = errorText;
        const bodyContent = `<div>
            <p>${headTextValue}</p>
            <div class="rm-config-item cs-form-v2">
                <ul class="cs-alerts-list js-error-message rm-config-hide">
                    <br></br>
                </ul>
                <div id="dataPinError" class="am-migration-form__error"></div>
                <label for="dataPinInput" class="rm-config-label">${labelText}</label>
                <input type="password"
                       name="dataPin"
                       id="dataPinInput"
                       class="rm-config-form-input rm-form-input rm-config-text-input">
            </div>
        </div>`;
        let modal = document.querySelector('bk-modal');
        if (!modal) {
            modal = document.createElement('bk-modal');
            this.appendChild(modal);
        }
        this.#modal = modal;
        modal.openModal({
            isDialog: true,
            titleText,
            bodyContent,
            submitText: submitTextValue,
            disableSubmitAt,
            submitFunction,
            onCloseCallback,
        });
    }

    showModalAsync(params = {}) {
        return new Promise((resolve, reject) => {
            let succeeded = false;
            const submitFunction = async () => {
                succeeded = true;
                const pin = document.querySelector('bk-modal #dataPinInput').value;
                const { isValidPin } = await this.validatePin({ pin: pin });
                console.log(isValidPin);
                if (!isValidPin) {
                    document.getElementById('dataPinError').textContent = this.#errorText;

                    return;
                }
                this.#modal.closeModal();
                resolve(pin);
            };
            const onCloseCallback = () => {};
            this.showModal({ ...params, submitFunction, onCloseCallback });
        });
    }

    async validatePin(data) {
        const resp = await fetch(BkModalDataPin.VALIDATE_PIN, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': csrf },
            body: JSON.stringify(data),
        });

        return resp?.json();
    }
}

export default BkModalDataPin;
